export const proofOfWorkHeaders = {
  /**
   * The proof of work challenge string sent by the server in response headers.
   */
  challenge: "X-Pow-Challenge",
  /**
   * The proof of work difficulty sent by the server in response headers.
   *
   * It is the number of leading 0 bytes to search for in the hash of the challenge + nonce.
   */
  difficulty: "X-Pow-Difficulty",
  /**
   * The proof of work solution string sent by the client in request headers.
   */
  solution: "X-Pow-Nonce",
} as const
